import CheckIcon from "@mui/icons-material/Check";
import FormControl from "@mui/material/FormControl";
import { Box } from "@mui/system";
import { Elements } from "@stripe/react-stripe-js";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import CheckoutForm from "../../Components/CheckoutForm/CheckoutForm";
import { API, getScreeningId } from "../../utils/http";
import stripePromise from "../../utils/stripe";

import { Button, Card, CardContent, Grid, List, ListItem, ListItemIcon, ListItemText, Stack, TextField, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { config } from "../../utils/config";
export default function Payment(props) {
	const applicationId = useSelector((state) => state.user.application.personalInformation).id;
	const { t } = useTranslation();
	const { handleNext, handleBack, renderControls } = props;
	const [clientSecret, setClientSecret] = useState("");
	const [isProductConfirmed, setIsProductConfirmed] = useState(false);
	const [selectedProduct, setSelectedProduct] = useState("extended");
	const [prices, setPrices] = useState([]);
	const [coupon, setCoupon] = useState();
	const [couponError, setCouponError] = useState();
	const appearance = {
		theme: "stripe",
	};

	let options = {
		clientSecret,
		appearance,
	};
	const handleChoseProduct = (e) => {
		setSelectedProduct(e.target.value);
		setIsProductConfirmed(false);
	};
	const navigate = useNavigate();
	const handleConfirm = (id) => {
		setSelectedProduct(id);
		if (id == "coupon") {
			if (!coupon) {
				console.log("error");
				setCouponError("Invalid coupon");
			} else {
				setCouponError();
				setIsProductConfirmed(true);
				API.post("process-coupon", { coupon, id: applicationId })
					.then((r) => {
						console.log(r);
						navigate(`${config.appUrl}/payment-status?coupon_message=succeeded`);
					})
					.catch((e) => {
						navigate(`${config.appUrl}/payment-status?coupon_message=error`);
					});
				console.log("proccess coupon and show result");
			}
		} else {
			setCouponError();
			setIsProductConfirmed(true);
			getClientSecret();
		}
	};
	const getClientSecret = () => {
		const screeningId = getScreeningId();
		console.log(selectedProduct);
		API.post(
			"create-payment-intent",
			{
				applicationType: selectedProduct,
				id: applicationId,
			},
			{
				params: { screeningId },
			}
		)
			.then((r) => {
				const data = r.data;
				console.log(data.clientSecret);
				setClientSecret(data.clientSecret);
			})
			.catch((e) => {
				console.log(e);
			});
	};
	useEffect(() => {
		console.log("getting prices");
		API.get("price").then((r) => {
			console.log(r);
			setPrices(r.data.payload);
		});
	}, []);
	const productOptions = [
		// {
		// 	id: "standard",
		// 	price: prices.find((p) => p.priceType.toLowerCase() == "standard")?.priceValue || "-",
		// 	label: "Standard CRC",
		// 	description: (
		// 		<Box>
		// 			<Typography>This check searches for an individual's criminal convictions under Canadian federal law. The information typically includes:</Typography>
		// 			<List dense={true}>
		// 				<ListItem>
		// 					<ListItemIcon>
		// 						<CheckIcon color="success" />
		// 					</ListItemIcon>
		// 					<ListItemText primary="Convictions for criminal offenses" />
		// 				</ListItem>
		// 				<ListItem>
		// 					<ListItemIcon>
		// 						<CheckIcon color="success" />
		// 					</ListItemIcon>
		// 					<ListItemText primary="The date and type of each conviction" />
		// 				</ListItem>
		// 				<ListItem>
		// 					<ListItemIcon>
		// 						<CheckIcon color="success" />
		// 					</ListItemIcon>
		// 					<ListItemText primary="The corresponding sentence or disposition, if available" />
		// 				</ListItem>
		// 			</List>
		// 		</Box>
		// 	),
		// },
		{
			id: "extended",
			price: prices.find((p) => p.priceType.toLowerCase() == "extended")?.priceValue || "-",
			label: "Purchase Extended CRC",
			description: (
				<Box>
					<Typography>This check searches for an individual's criminal convictions under Canadian federal law. The information typically includes:</Typography>
					<List dense={true}>
						<ListItem>
							<ListItemIcon>
								<CheckIcon color="success" />
							</ListItemIcon>
							<ListItemText primary={t("Criminal convictions")} />
						</ListItem>
						<ListItem>
							<ListItemIcon>
								<CheckIcon color="success" />
							</ListItemIcon>
							<ListItemText primary={t("The date and type of each conviction")} />
						</ListItem>
						<ListItem>
							<ListItemIcon>
								<CheckIcon color="success" />
							</ListItemIcon>
							<ListItemText primary={t("The corresponding sentence or disposition, if available")} />
						</ListItem>
						<ListItem>
							<ListItemIcon>
								<CheckIcon color="success" />
							</ListItemIcon>
							<ListItemText primary={t("Outstanding charges and arrest warrants")} />
						</ListItem>
						<ListItem>
							<ListItemIcon>
								<CheckIcon color="success" />
							</ListItemIcon>
							<ListItemText primary={t("Absolute and conditional discharges (within the past 3 years)")} />
						</ListItem>
						<ListItem>
							<ListItemIcon>
								<CheckIcon color="success" />
							</ListItemIcon>
							<ListItemText primary={t("Court orders, such as peace bonds and probation orders")} />
						</ListItem>
					</List>
				</Box>
			),
		},
		{
			id: "coupon",
			label: "Use Prepaid Code",
			description: (
				<Box>
					<Typography>{t("This prepaid code has been provided to you by the organization who requested the Record Check")}</Typography>
				</Box>
			),
		},
	];
	return isProductConfirmed && selectedProduct != "coupon" ? (
		<Box>
			{clientSecret == "" ? (
				<>Loading...</>
			) : (
				<Stack spacing={2}>
					<Card>
						<CardContent>
							<Typography fontWeight={"bold"}>{t("Summary")}</Typography>
							<Box style={{ textAlign: "right", width: "fit-content" }}>
								<Typography>
									{`1 x ${t(productOptions.find((p) => p.id == selectedProduct).label)} = `}
									<strong>{Number(productOptions.find((p) => p.id == selectedProduct).price).toFixed(2)} CAD</strong>
								</Typography>
								<Typography>
									{`HST (13%) = `}
									<strong>{Number(0.13 * productOptions.find((p) => p.id == selectedProduct).price).toFixed(2)} CAD</strong>
								</Typography>
								<Typography>
									{`${t("Total Amount")} = `}
									<strong>{Number(1.13 * productOptions.find((p) => p.id == selectedProduct).price).toFixed(2)} CAD</strong>
								</Typography>
							</Box>
						</CardContent>
					</Card>
					<Elements options={options} stripe={stripePromise}>
						<CheckoutForm />
					</Elements>
				</Stack>
			)}
			{renderControls(handleNext, handleBack, true)}
		</Box>
	) : (
		<Stack alignItems={"left"} marginBottom={"36px"} gap={2}>
			<Typography>{t("Please select type")}</Typography>
			<Typography>{t("Check with organization")}</Typography>

			<Grid container spacing={2}>
				{productOptions.map((p) => (
					<Grid item xs={12} md={6}>
						<Card style={{ height: "100%" }}>
							<CardContent style={{ height: "100%" }}>
								<Stack direction={"column"} style={{ height: "100%" }} justifyContent={"space-between"}>
									<Box>
										<Typography variant="h6" fontWeight={"bold"} textAlign={"center"}>
											{t(p.label)}
										</Typography>
										{p.price ? (
											<Typography gutterBottom variant="h6" fontWeight={"bold"} textAlign={"center"}>
												{Number(p.price).toFixed(2)} CAD
											</Typography>
										) : (
											<Box marginBottom="16px" textAlign="center">
												<Typography gutterBottom variant="h6" fontWeight={"bold"} textAlign={"center"}>
													{t("Free")}
												</Typography>
												<FormControl>
													<TextField
														error={couponError}
														helperText={couponError}
														size="small"
														label="Code"
														variant="outlined"
														// value={quantity}
														onChange={(e) => {
															setCoupon(e.target.value);
														}}
														// type="number"
														// style={{ width: "150px" }}
													/>
												</FormControl>
											</Box>
										)}

										<Box>{p.description}</Box>
									</Box>
									<Box textAlign={"center"}>
										<Button
											variant="outlined"
											style={{ textTransform: "capitalize" }}
											onClick={() => {
												handleConfirm(p.id);
											}}
										>
											{t(p.label)}
										</Button>
									</Box>
								</Stack>
							</CardContent>
						</Card>
					</Grid>
				))}
			</Grid>
			{/* <Grid container>
					<FormControl>
						<RadioGroup onChange={handleChoseProduct} row value={selectedProduct}>
							{productOptions.map((p) => (
								<Grid item xs={12} md={4}>
									<FormControlLabel
										labelPlacement="bottom"
										value={p.id}
										control={<Radio />}
										label={
											<Paper>
												<Card>
													<CardContent>
														<Typography variant="h6" fontWeight={"bold"} textAlign={"center"}>
															{p.label}
														</Typography>
														{p.price ? (
															<Typography gutterBottom variant="h6" fontWeight={"bold"}>
																CAD {p.price}
															</Typography>
														) : (
															<FormControl>
																<TextField
																	error={couponError}
																	helperText={couponError}
																	size="small"
																	label="Code"
																	variant="outlined"
																	// value={quantity}
																	onChange={(e) => {
																		setCoupon(e.target.value);
																	}}
																	// type="number"
																	// style={{ width: "150px" }}
																/>
															</FormControl>
														)}

														{p.description}
													</CardContent>
												</Card>
											</Paper>
										}
									/>
								</Grid>
							))}
						</RadioGroup>
					</FormControl>
				</Grid> */}
		</Stack>
	);
}
